// src/features/hmi-simulator/hooks/useHMIApi.ts
import { useState, useCallback } from 'react';
import { useNotify } from 'react-admin';
import { hmiDataProvider } from '../services/hmiDataProvider';

export const useHMIApi = () => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const execute = useCallback(async <T = any>(
    apiCall: () => Promise<T>,
    options?: {
      successMessage?: string;
      errorMessage?: string;
      showError?: boolean;
    }
  ): Promise<T | null> => {
    setLoading(true);
    setError(null);

    try {
      const result = await apiCall();
      
      if (options?.successMessage) {
        notify(options.successMessage, { type: 'success' });
      }
      
      return result;
    } catch (err: any) {
      const errorMsg = err.message || options?.errorMessage || 'Ha ocurrido un error';
      setError(errorMsg);
      
      if (options?.showError !== false) {
        notify(errorMsg, { type: 'error' });
      }
      
      return null;
    } finally {
      setLoading(false);
    }
  }, [notify]);

  return {
    loading,
    error,
    execute,
    api: hmiDataProvider,
  };
};